import { InjectionToken } from '@angular/core';

import { Observable } from 'rxjs';

import { Country } from '@recruitee/http/types';

import { SelectOption } from '../forms/select/select.component';

export type CountrySelectOption = SelectOption & { countryCode: string };

export const PHONE_INPUT_DATA = new InjectionToken<Observable<Country[]>>('PHONE_INPUT_DATA');
